import React from 'react'
import clsx from 'clsx'
import {Link, useLocation} from 'react-router-dom'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout} from '../../core'
import 'font-awesome/css/font-awesome.min.css'
import { useSelector } from 'react-redux'
import { getSidebarRedDotData } from '../../../../app/pages/UserPages/inbox/InboxSlice/InboxSlice'
import './aside-menu-item.scss'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  exactUrl?: boolean
  parent?: string
  onClick?: () => void
  level?: number
  newNavigation?: boolean
}

const AsideMenuItem: React.FC<Props> = ({
  // @ts-ignore
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  exactUrl = false,
  parent,
  onClick,
  level,
  newNavigation,
}) => {
  const { pathname, search } = useLocation()
  const isActive = checkIsActive(pathname, to, search, exactUrl, parent)
  const { config } = useLayout()
  const { aside } = config
  const sidebarRedDotData = useSelector(getSidebarRedDotData)

  return (
    <>
      <div className={clsx('menu-item',
        {
          'menu-active-bg': isActive && newNavigation,
          'menu-level-2': level === 2 && newNavigation,
          'new-navigation': newNavigation,
        })} data-kt-menu-trigger='click'>
        <Link className={clsx('menu-link without-sub', { active: isActive })} to={to} onClick={onClick}>
          {hasBullet ? (
            <span className='menu-bullet'>
              <span className='bullet bullet-dot'></span>
            </span>
          ) : (
            <>
              {icon && aside.menuIcon === 'svg' && (
                <div className='position-relative'>
                  <span className='menu-icon'>
                    <KTSVG path={icon} className='svg-icon-2' />
                  </span>
                  {sidebarRedDotData?.isUnreadMessage && title === 'Inbox' ? (
                    <span className='red-dot-top-right'></span>
                  ) : null}
                </div>
              )}

              {icon === '' && fontIcon !== '' && (
                <div className='position-relative '>
                  <span className='menu-icon'>
                    <i className={clsx('bi fs-3', fontIcon)}></i>
                  </span>
                </div>
              )}

              {!icon && !fontIcon && (
                <span className={clsx('menu-bullet', { 'ms-4': level === 2 })}>
                  <span className=''></span>
                </span>
              )}
            </>
          )}

          <div className='d-flex justify-content-center gap-2'>
            <span className='menu-title' data-testid={title} style={{ fontSize: '14px' }}>
              {title}
            </span>
            {sidebarRedDotData?.unread && title === 'Inbox' ? (
              <div className="badge rounded-pill bg-danger py-1 px-3 inbox-count-badge d-flex justify-content-center align-items-center">
                {sidebarRedDotData?.unread}
              </div>
            ) : null}
          </div>
        </Link>
        {children}
      </div>
    </>
  )
}

export { AsideMenuItem }
